export { default as SoundIcon } from './SoundIcon';